import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../../../hooks/useAxiosClient";
import { TRootState } from "../../../store";
import { toast } from "react-toastify";
import { TCompositionsData } from "../../../types/eiskEngine";
import {
  resetCategoryWeights,
  setCompositionsData,
} from "../../../reducers/riskEngineSlice";

const useComposition = () => {
  const { handleGetCall, handlePostCall } = useAxiosClient();
  const dispatch = useDispatch();

  const { adminId, categoryWeights, compositionsData } = useSelector(
    (state: TRootState) => ({
      adminId: state.auth.adminId,
      categoryWeights: state.riskEngineDetailsSlice.categoryWeights,
      compositionsData: state.riskEngineDetailsSlice.compositionsData,
    })
  );

  const handleSave = async (customPayload?: Record<string, number>) => {
    let payload: Record<string, number>;
    if (customPayload) {
      payload = customPayload;
    } else {
      const categories = compositionsData?.categories || [];
      payload = Object.fromEntries(
        categories.map((c) => [
          c.category_name.toLowerCase().replace(/\s+/g, "_"),
          Number(c.weight),
        ])
      ) as Record<string, number>;
    }

    const total = Object.values(payload).reduce(
      (sum, val) => sum + Number(val),
      0
    );

    if (total !== 100) {
      toast.error(`Total weights must be equal to 100%. Got ${total}`);
      return;
    }

    const obj = {
      financial: payload.financial ?? 0,
      transaction: payload.transaction ?? 0,
      amid: payload.amid ?? 0,
      credit_score: payload.credit_score ?? 0,
    };
    handlePostCall({
      URL: `solutions/risk-engine/${adminId}/risk-comp`,
      apiParams: obj,
    })
      .then(({ data, status }) => {
        toast.success(status.description);
        getCompositiondetails();
      })
      .catch((err: any) => {});
  };
  const getCompositiondetails = () => {
    handleGetCall<TCompositionsData>(
      `solutions/risk-engine/adminId/${adminId}/risk-comp`
    )
      .then(({ data }) => {
        if (data) {
          dispatch(setCompositionsData(data));
        } else {
          //   dispatch(setCompositionsData());
        }
      })
      .catch((err: any) => {
        toast.error(err.response.data.status.description);
      });
  };
  useEffect(() => {
    getCompositiondetails();
  }, []);
  const handleResetWeights = () => {
    const resetPayload: Record<string, number> = {
      financial: 25,
      transaction: 25,
      amid: 25,
      credit_score: 25,
    };
    dispatch(resetCategoryWeights());
    handleSave(resetPayload);
  };
  return { handleSave, categoryWeights, compositionsData, handleResetWeights };
};
export default useComposition;
